// extracted by mini-css-extract-plugin
export default {"testTab":"TestTab_testTab__gNAOq"};